// @flow

import React from 'react';
import CrossSellGauge from './CrossSellGauge';
import type { CrossSellBean } from '../../../../../types/apolloType';
import { getPrettifyValue } from '../../../../../utils/formatUtils';

type Props = {
  isInShoppingCenter: boolean,
  crossSell: CrossSellBean,
}

function CrossSellRetailer({ crossSell, isInShoppingCenter }: Props) {
  return (
    <div className={`cross-sell-retailer${isInShoppingCenter ? ' cross-sell-retailer--border' : ''}`}>
      <div className="cross-sell-presentation">
        {
          crossSell.crossedRetailerLogo
            ? (
              <img src={crossSell.crossedRetailerLogo} alt="logo" />
            ) : (
              <span>{crossSell.crossedRetailerName}</span>
            )
        }
      </div>
      <CrossSellGauge crossSellPercentage={crossSell.crossSalesRate} />
      <div className="cross-sell-result">
        <span>{getPrettifyValue(crossSell.crossSalesRate, 1)}</span>
      </div>
    </div>
  );
}

export default CrossSellRetailer;

